var React = require('react');

function PageBack (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"fill":"#212121","d":"M12,0C5.373,0,0,5.373,0,12v344.926c0,6.627,5.373,12,12,12h285c6.627,0,12-5.373,12-12V47.319L261.682,0\r\n\t\t\tH12z"}))));
}

PageBack.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"309px","height":"368.926px","viewBox":"0 0 309 368.926","enableBackground":"new 0 0 309 368.926","xmlSpace":"preserve"};

module.exports = PageBack;

PageBack.default = PageBack;
